import OurPresence from "./OurPresence";

const HotLocations = ({ hotlocationData, OurPresenceData, formdata }) => {
  const backgroundImage = hotlocationData.background;
  const title = hotlocationData.title;
  const tagline = hotlocationData.tagline;
  const data = hotlocationData.data;

  return (
    <>
      <section className="apartment-one py-20">


        <div
          className="apartment-one__bg"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        />

        <div className="container">
          <div className="section-title text-center -mt-10">
            <h2 className="section-title__title ">{title}</h2>
            <span className="section-title__tagline">{tagline}</span>

            <OurPresence OurPresenceData={OurPresenceData} />
          </div>
        </div>


      </section>
    </>
  );
};

export default HotLocations;
